module.exports = "//static.hsappstatic.net/LoginUI/static-1.15413/img/HubSpot-sprocket-color.png"